@if (pageTitleConfig?.showPageTitleBar) {
  <div class="page-title-container bg-white py-2 ps-1">
    <div class="row g-0">
      <!-- Row: 1, Column: 1 => Title Bar Section -->
      <div class="page-title-name-wrapper" [ngClass]="pageTitleConfig?.pageTitleWrapperClass || 'col-8 col-md-8 align-items-start'">
        <!-- Search Bar -->
        @if (pageTitleConfig?.input?.display) {
          <input [(ngModel)]="lookupWord" (ngModelChange)="searchStringUpdate.next($event)" class="form-control" placeholder="{{ pageTitleConfig?.input?.placeholder }}" />
        }
        <!-- Page Title Back button -->
        @if (pageTitleConfig?.backBtn) {
          <p class="mb-1 back-btn-caption font-size-14 link-nav">
            <a href="{{ pageTitleConfig?.backBtn?.stateName }}" [routerLink]="pageTitleConfig?.backBtn?.stateName" [id]="pageTitleConfig?.backBtn?.id">
              <img class="img-fluid back-arrow" src="assets/images/back-button.svg" id="app-header-pgtitle-ic-back" alt="Back" />
            </a>
            <span class="d-inline-block align-middle ms-1">{{ pageTitleConfig?.backBtn?.label }}</span>
          </p>
        }
        <!-- Page Title -->
        @if (pageTitleConfig?.title?.label) {
          <h2 class="text-capitalize mb-0 d-inline-block">
            <span class="d-inline-block fw-bold text-truncate font-size-24" id="app-header-pgtitle-title" placement="bottom" ngbTooltip="{{ pageTitleConfig?.title?.label }}" [disableTooltip]="pageTitleConfig?.title?.disableTooltip || false">
              {{ pageTitleConfig?.title?.label }}
            </span>
          </h2>
        }
      </div>
      <!-- Row: 1, Column: 2 => Action Bar Section -->
      @if (pageTitleConfig?.options) {
        <div id="{{ pageTitleConfig?.id }}" [ngClass]="pageTitleConfig?.pageTitleActionWrapperClass || 'col-12 col-md-4 align-items-end'">
          <ul class="list-inline action-bar mb-0 mt-1 font-size-14 text-end me-2">
            @for (option of pageTitleConfig?.options; track option.id; let i = $index) {
              <li class="list-inline-item fw-bold">
                @if (!option.display) {
                  <!-- Page Title -->
                  @if (option?.label && option.type === 'text' && !option.display) {
                    <span class="font-size-16" id="{{ option.id }}" (click)="btnClickCallback({ type: option.type, key: option?.value })"
                      >{{ option?.label }}:
                      <span [ngClass]="i === 0 ? 'fw-bold' : ''">{{ option?.value }}</span>
                    </span>
                  }
                  <!-- Action button bar With out Permission Scope defined -->
                  @if (option.type === 'button' && !option.permissionScope) {
                    <button
                      id="{{ pageTitleConfig?.backBtn?.id }}"
                      class="btn"
                      [ngClass]="option?.cssClass || 'fw-bold btn-primary'"
                      (click)="btnClickCallback({ type: option.type, key: option?.value, id: option?.id, routerLink: option?.routerLink })">
                      <span>
                        @if (option?.icon) {
                          <i [ngClass]="option.icon"></i>
                        }
                        {{ option?.value }}</span
                      >
                    </button>
                  }
                  <!-- Action button bar With Permission Scope defined -->
                  @if (option.type === 'button' && option.permissionScope) {
                    <button
                      *ngxPermissionsOnly="option.permissionScope"
                      id="{{ pageTitleConfig?.backBtn?.id }}"
                      class="btn"
                      [ngClass]="option?.cssClass || 'fw-bold btn-primary'"
                      (click)="btnClickCallback({ type: option.type, key: option?.value, id: option?.id, routerLink: option?.routerLink })">
                      <span>
                        @if (option?.icon) {
                          <i [ngClass]="option.icon"></i>
                        }
                        {{ option?.value }}</span
                      >
                      <!-- Badge -->
                      @if (badgeMessageText) {
                        <span [ngClass]="option?.alertBadge?.cssClass" class="d-flex align-items-center justify-content-center position-absolute alert-badge translate-middle rounded-circle">
                          <span class="visually-hidden">{{ badgeMessageText }}</span>
                          {{ badgeMessageText }}
                        </span>
                      }
                    </button>
                  }
                }
              </li>
            }
            @if (pageTitleConfig?.dropdown) {
              <li class="list-inline-item fw-bold font-size-16">
                <div ngbDropdown class="d-inline-block">
                  <a class="link-primary" id="pageTitleConfig?.dropdown.id" ngbDropdownToggle>Share</a>
                  <div ngbDropdownMenu aria-labelledby="pageTitleConfig?.dropdown.id" class="cs-dd-model">
                    @for (option of pageTitleConfig?.dropdown?.value; track option) {
                      <a ngbDropdownItem (click)="selectItem(option?.value)">{{ option?.value }}</a>
                    }
                  </div>
                </div>
              </li>
            }
            @if (pageTitleConfig?.canDelete) {
              <li class="list-inline-item fw-bold" (click)="btnClickCallback({ type: 'link', key: pageTitleConfig?.title?.label })">
                <a class="link-primary" id="app-header-pgtitle-option-lnk-label-delete" href="javascript:void(0);">
                  <i class="bi bi-trash"></i>
                  <span class="visually-hidden">Delete</span>
                </a>
              </li>
            }
            @for (option of pageTitleConfig?.options; track option.id) {
              @if (option.display) {
                <li class="status-display font-size-12">
                  <span>
                    <b>{{ option?.label }}:</b>
                    @if (option.type === 'date') {
                      {{ option?.value | date: 'dd MMM yyyy' }},
                      {{ option?.value | date: 'hh:mm a' }}
                      {{ option?.valueSuffix }}
                    } @else {
                      {{ option?.value }}
                    }
                  </span>
                </li>
              }
            }
          </ul>
        </div>
      }
      <!-- Row: 2, Column: 1 => Sub Title Bar Section -->
      @if (pageTitleConfig?.subTitle?.label) {
        <div [ngClass]="pageTitleConfig?.pageTitleActionWrapperClass || 'col-12 ps-md-0'">
          @if (pageTitleConfig?.hasOwnProperty('subTitle')) {
            <p class="mb-0 d-inline-block">
              <span class="d-inline-block text-truncate font-size-14" id="app-header-pgtitle-sub-title" placement="bottom" ngbTooltip="{{ pageTitleConfig?.subTitle?.label }}" [disableTooltip]="pageTitleConfig?.subTitle?.disableTooltip || false">
                {{ pageTitleConfig?.subTitle?.label }}
              </span>
            </p>
          }
        </div>
      }
    </div>
  </div>
}
